import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import Layout from "./components/layout/Layout";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer } from "react-toastify";
import { Context } from "./context/stateContext";
import UserSession from "./pages/Administration/UserSession";
import SaleReceipt from "./pages/POS/SaleReceipt";
import ForgotPassword from "./pages/auth/ForgotPassword";
import DispenserBranchVerify from "./pages/auth/DispenserBranchVerify";
import RoleBasedRoutes from "./routes/RoleBasedRoutes";
import UserManagement from "./UserManagement";

function App() {
  return (
    <BrowserRouter>
      <Context>
        <Routes>
          <Route path="/" exact element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/user/status" element={<UserSession />} />
          <Route
            path="/dispenser/verify-branch"
            element={
              <RoleBasedRoutes
                allowedRoles={["dispenser", "branch_manager"]}
                component={DispenserBranchVerify}
                fallback="/not-found"
              />
            }
          />
          <Route path="/*" element={<ProtectedRoutes component={Layout} />} />
          <Route path="/inventory/sale-receipt" element={<SaleReceipt />} />
          <Route path="/user-management" element={<UserManagement />} />
        </Routes>
      </Context>
      <ToastContainer
        position="top-right"
        autoClose={6608}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  );
}

export default App;
